import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'gatsby';

import config from '../utils/config';
import SocialIcons from './SocialIcons';
import ScrollButton from './ScrollButton';

const ParrlaxContainer = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
`;

const Container = styled.footer`
  margin-top: 2rem;
  padding: 5rem 1.5rem 4rem;
  @media only screen and (max-width: 768px) {
    padding: 4rem 1.5rem 1.5rem;
  }
  background-color: #191919;
  position: relative;
  p {
    font-weight: 500;
  }
  li {
    margin-bottom: 1rem;
  }
  a {
    font-weight: 300;
  }
  .career-text {
    line-height: 28px;
    font-weight: 300;
  }
  @media only screen and (max-width: 768px) {
    li {
      margin-bottom: 0.5rem;
    }
  }
`;

const Heading = styled.p`
  margin-bottom: 1rem;
  @media only screen and (max-width: 768px) {
    margin-bottom: 0.5rem;
  }
`;

const Bottom = styled.div`
  background-color: #191919;
  width: 100%;
  .section {
    padding: 1.5rem 1.5rem 0;
  }
`;

const SocialIconsWrapper = styled.div`
  .column {
    display: flex;
    justify-content: center;
  }
`;

const firstItems = [
  { id: 1, name: 'Contact Us', url: '/contact' },
  { id: 2, name: 'About Us', url: '/page/about' },
  { id: 3, name: 'Careers', url: '/page/careers' },
  { id: 4, name: 'Register as Sell', url: '/sell-on-information/' },
];

const secondItems = [
  { id: 1, name: 'FAQ', url: '/page/faq' },
  { id: 2, name: 'Terms of Use', url: '/page/terms-and-condition' },
  { id: 3, name: 'Privacy Policy', url: '/page/privacy-policy' },
  { id: 4, name: 'Blogs', url: '/blog' },
];

const thirdItems = [
  { id: 1, name: 'Delivery Info', url: '/page/delivery-information' },
  {
    id: 2,
    name: 'Warehouse Returns to Seller',
    url: '/page/warehouse-returns-to-seller',
  },
  { id: 3, name: 'Reverse Shipment (RVP)', url: '/page/reverse-shipment-rvp' },
  {
    id: 4,
    name: 'Returns',
    url: '/page/return-policy',
  },
];

const Footer = ({ home }) => {
  return (
    <ParrlaxContainer>
      <Container className="section">
        <div className="container">
          <div className="columns is-multiline">
            <div className="column has-text-centered">
              <Heading className="is-size-6 has-text-warning-dark">
                W Trade India
              </Heading>
              <ul>
                {firstItems.map((item) => (
                  <li key={item.id}>
                    <Link to={item.url} className="has-text-white">
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="column has-text-centered">
              <Heading className="is-size-6 has-text-warning-dark">
                Our Information
              </Heading>
              <ul>
                {secondItems.map((item) => (
                  <li key={item.id}>
                    <Link to={item.url} className="has-text-white">
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="column has-text-centered">
              <Heading className="is-size-6 has-text-warning-dark">
                Policy
              </Heading>
              <ul>
                {thirdItems.map((item) => (
                  <li key={item.id}>
                    <Link to={item.url} className="has-text-white">
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="column has-text-white has-text-centered">
              <Heading className=" is-size-6 has-text-warning-dark">
                Career
              </Heading>
              <ul>
                <li>
                  <p className="has-text-white career-text">
                    We are always looking for passionate team mates to join us
                    in our mission.
                  </p>
                </li>
              </ul>
              <ul>
                <li>
                  <Link
                    to="/sell-on-information"
                    className="has-text-warning-dark has-text-weight-normal"
                  >
                    Join Us
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <Bottom>
          <div className="section has-text-centered">
            <div className="container">
              <Heading className="is-uppercase is-size-6 has-text-warning-dark">
                Follow
              </Heading>
              <SocialIconsWrapper className="columns has-text-centered">
                <div className="column">
                  <SocialIcons inverted data={home} />
                </div>
              </SocialIconsWrapper>
              <div className="columns is-centered">
                <div className="column is-6 has-text-white">
                  {' '}
                  <p className="has-text-white has-text-weight-light">
                    Copyright © 2020 - {config.siteName} | build by{' '}
                    <a
                      className="has-text-white"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="http://www.digimap.in/"
                    >
                      digimap.in
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Bottom>
        <ScrollButton scrollStepInPx="50" delayInMs="16.66" />
      </Container>
    </ParrlaxContainer>
  );
};

Footer.defaultProps = {
  home: {},
};

Footer.propTypes = {
  home: PropTypes.object,
};

export default Footer;
